// extracted by mini-css-extract-plugin
export default {"responsiveMap":"Map_responsiveMap__3pAro","mapSkeleton":"Map_mapSkeleton__D1XNp"};